/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_OutdoorInputs */

const en_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdoor`)
};

const es_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exterior`)
};

const fr_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extérieur`)
};

const de_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdoor`)
};

const ja_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アウトドア`)
};

const zh_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`户外`)
};

const ar_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخارج`)
};

const id_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luar Ruangan`)
};

const it_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esterni`)
};

const ru_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На открытом воздухе`)
};

const pt_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área Externa`)
};

const ko_val_outdoor = /** @type {(inputs: Val_OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`야외용`)
};

/**
* | output |
* | --- |
* | "Outdoor" |
*
* @param {Val_OutdoorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_outdoor = /** @type {((inputs?: Val_OutdoorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_OutdoorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_outdoor(inputs)
	if (locale === "es") return es_val_outdoor(inputs)
	if (locale === "fr") return fr_val_outdoor(inputs)
	if (locale === "de") return de_val_outdoor(inputs)
	if (locale === "ja") return ja_val_outdoor(inputs)
	if (locale === "zh") return zh_val_outdoor(inputs)
	if (locale === "ar") return ar_val_outdoor(inputs)
	if (locale === "id") return id_val_outdoor(inputs)
	if (locale === "it") return it_val_outdoor(inputs)
	if (locale === "ru") return ru_val_outdoor(inputs)
	if (locale === "pt") return pt_val_outdoor(inputs)
	return ko_val_outdoor(inputs)
});